import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const ActionsMenu = ({ status, onDelete, onToggleBlock, onAllowPermission }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {/* <MenuItem
          onClick={() => {
            onAllowPermission();
            handleClose();
          }}
        >
          Allow Permission
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            onDelete();
            handleClose();
          }}
        >
          Delete
        </MenuItem>

        <MenuItem
          onClick={() => {
            onToggleBlock();
            handleClose();
          }}
        >
          {status ? "Block" : "Unblock"}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ActionsMenu;
